import { normalizeRootDomain } from "@repo/shared";

// Runtime configuration that is set when the web container starts, not at build
// time. The nginx image renders `index.html` from a template on every start
// (apps/web/docker/40-qp-runtime-config.sh), replacing the placeholders in the
// <meta> tags below. The same image can therefore run on any domain.

const ROOT_DOMAIN_META = "qp-root-domain";
const ROOT_DOMAIN_PLACEHOLDER = "__QP_ROOT_DOMAIN__";

function readMeta(name: string, placeholder: string): string | null {
  const content = document.querySelector(`meta[name="${name}"]`)?.getAttribute("content") ?? "";
  return content === "" || content === placeholder ? null : content;
}

/**
 * QL-343 — the root domain (`host[:port]`) tenants are served under as
 * `<slug>.<rootDomain>`, or `null` when tenant subdomains are disabled.
 *
 * Local dev (`bun index.html`, Vite) has no container start, so the placeholder
 * stays and `BUN_PUBLIC_ROOT_DOMAIN` from apps/web/.env is used instead.
 */
export function getRootDomain(): string | null {
  const fromMeta = readMeta(ROOT_DOMAIN_META, ROOT_DOMAIN_PLACEHOLDER);
  if (fromMeta !== null) return normalizeRootDomain(fromMeta);
  // The bundler inlines the expression when the variable is set; when it is
  // absent `process` is left in place and does not exist in the browser.
  let fromEnv: string | undefined;
  try {
    fromEnv = process.env.BUN_PUBLIC_ROOT_DOMAIN;
  } catch {
    fromEnv = undefined;
  }
  return normalizeRootDomain(fromEnv);
}
